'use es6';

export const FAIL = 'FAIL';
export const PENDING = 'PENDING';
export const PASS = 'PASS';